import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5003 17.5013L12.3364 12.3374M12.3364 12.3374C13.4674 11.2064 14.167 9.64389 14.167 7.91797C14.167 4.46619 11.3687 1.66797 7.91699 1.66797C4.46521 1.66797 1.66699 4.46619 1.66699 7.91797C1.66699 11.3697 4.46521 14.168 7.91699 14.168C9.64291 14.168 11.2054 13.4684 12.3364 12.3374Z",
		stroke: "#EFEEF0",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})
});
export default SvgSearch;
